import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { jsonResponseHandler } from '../utils/FetchHelper'
import { receiveAllData } from '../actions/design/blogmenu'
import BlogMenuForm from "../components/blogmenu/BlogMenuForm"
import LoadingBox from "../components/common/LoadingBox";
import * as InitStatus from '../constants/common/InitializationStatus';
import LoadErrorBox from "../components/common/LoadErrorBox";
import {addPrefix} from "../utils/UriUtil";

export default function BlogMenuApp() {
  const dispatch = useDispatch()
  const [initialized, setInitialized] = useState(InitStatus.INIT_READY)
  function init() {
    setInitialized(InitStatus.INIT_DOING)
    fetch(addPrefix("/manage/design/menu.json"), {
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        dispatch(receiveAllData(data.types, data.menus, data.isEditableMenu))
        setInitialized(InitStatus.INIT_SUCCESS)
      })
      .catch(e => {
        console.error(e);
        setInitialized(InitStatus.INIT_FAIL)
      })
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <div className="inner_article decoration_article">
      <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
      { (initialized === InitStatus.INIT_DOING ) && <LoadingBox />}
      { (initialized === InitStatus.INIT_FAIL ) && <LoadErrorBox retry={this.init}/>}
      { (initialized === InitStatus.INIT_SUCCESS ) &&
        <div className="blog_menu">
          <h3 className="tit_cont">메뉴</h3>
          <BlogMenuForm />
        </div>
      }
    </div>
  )
}
